import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";

import { useAuthStore } from "../../../store/auth";

import fetch from "../../../utils/fetch";

import Title from "../../../components/main/title";
import Input from "../../../components/main/input";
import Button from "../../../components/main/button";

interface Props {
    footer: any;
}

const bg: any = [];
const bg_rand = bg[Math.floor(Math.random() * 5)];

const Login: React.FC<Props> = ({ footer }) => {
    const loggedIn = useAuthStore<any>((s) => s.loggedIn);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [buttonActive, setButtonActive] = useState({ login: false });

    const login = () => {
        setButtonActive({ ...buttonActive, login: true });
        const post = new fetch(
            "/auth/login",
            {
                email: email,
                password: password,
            },
            { success: true, error: true }
        ).post();

        post.then((res) => {
            if (res.status === "success") {
                if (window.location.search.split("?").length > 1) {
                    if (window.location.search.split("?")[1].split("=")[0] === "redirect") {
                        window.location.href = window.location.search.split("redirect=")[1];
                    } else {
                        window.location.href = "/dashboard";
                    }
                } else {
                    window.location.href = "/dashboard";
                }
            }
            setButtonActive({ ...buttonActive, login: false });
        }).catch((e) => {
            setButtonActive({ ...buttonActive, login: false });
        });
    };

    if (loggedIn === true) {
        window.location.href = "/dashboard";
        return <></>;
    }

    return (
        <>
            <div id="login">
                <div>
                    <div className="auth-header-logo">
                        <span
                            className="logo-title"
                            onClick={() => {
                                window.location.href = "/";
                            }}
                        >
                            YPC VCA
                        </span>
                    </div>
                    <Title title="h2" value="Log in" />
                    <Input
                        name="email"
                        type="email"
                        placeholder="Email"
                        updateChange={(value) => {
                            setEmail(value);
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                login();
                            }
                        }}
                    />
                    <Input
                        name="password"
                        type="password"
                        placeholder="Password"
                        updateChange={(value) => {
                            setPassword(value);
                        }}
                        onKeyDown={(e) => {
                            if (e.keyCode === 13) {
                                login();
                            }
                        }}
                    />
                    <div className="w-100 small">
                        <a href="/forgot-password">Forgot password</a>
                    </div>
                    <div className="text-right">
                        <Button
                            value="Login"
                            disabled={buttonActive.login}
                            onClick={() => {
                                login();
                            }}
                        />
                    </div>
                    {footer}
                </div>
                <div className="position-relative" style={{ backgroundColor: "#155bd5" }}>
                    <div className="auth-bg-msg"></div>
                </div>
            </div>
        </>
    );
};

export default Login;
